import classNames from "classnames";

import {openZendeskArticle} from "@/lib/integrations/zendesk.ts";

interface SupportLinkProps {
  className?: string;
  href: string;
  text?: string;
  openInZendesk?: boolean;
}

export const SupportLink = ({className, href, text, openInZendesk = true}: SupportLinkProps) => (
  <a
    href={href}
    className={classNames(className)}
    target={"_blank"}
    onClick={(e) => {
      if (openInZendesk && href.startsWith("https://support.uptime.com/")) {
        e.preventDefault();
        openZendeskArticle(href);
      }
    }}
  >
    <span>{text ?? "View Documentation"}</span>
  </a>
);
